import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useNavigate } from "react-router-dom"; 
import DataTableMUI from "../../components/common/DataTable";
import { organCategoryColumns } from "../../services/tableColomn";
import ViewDataPopup from "./viewDataPopup";
import {
  deleteOrganCategory,
  getAllOrganCategories,
  undoDeleteOrganCategory,
} from "../../redux/slices/organCategorySlice";

const statusOptions = [
  { value: "all", label: "ALL", color: "#2563eb" },
  { value: "active", label: "ACTIVE", color: "#388e3c" },
  { value: "inactive", label: "INACTIVE", color: "#bfa100" },
  { value: "deleted", label: "DELETED", color: "#d32f2f" },
];

const OrganCategory = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { organCategory, loading, statusCounts, pagination } = useAppSelector(
    (state) => state.organCategory
  );

  const [viewPopupOpen, setViewPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      getAllOrganCategories({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );
  }, [dispatch, statusFilter, page, search, itemsPerPage, sortKey, sortOrder]);

  useEffect(() => {
    refetch();
  }, []);

  const refetch = () =>
    dispatch(
      getAllOrganCategories({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handlePageChange = (newPage) => setPage(newPage);

  const handleView = (row) => {
    setSelectedRow(row);
    setViewPopupOpen(true);
  };

  const handleEdit = (row) => {
    navigate("/organ-category-form", {
      state: { editData: row },
    });
  };

  const handleDelete = async (row) => {
    if (window.confirm("Are you sure you want to delete this field?")) {
      await dispatch(deleteOrganCategory(row._id));
      refetch();
    }
  };

  const handleUndo = async (row) => {
    await dispatch(undoDeleteOrganCategory(row._id));
    refetch();
  };

  const handleSort = (col) => {
    if (!col.sortable) return;
    setSortKey(col.accessor);
    setSortOrder(
      sortKey === col.accessor && sortOrder === "asc" ? "desc" : "asc"
    );
    setPage(1);
  };

  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
  };

  const statusOpts = statusOptions.map((opt) => ({
    ...opt,
    count: statusCounts?.[opt.value] || 0,
  }));

  // Ensure organCategory is always an array
  const safeOrganCategory = Array.isArray(organCategory) ? organCategory : [];

  return (
    <div className="data-table">
      <DataTableMUI
        title="Organ Category"
        columns={organCategoryColumns}
        data={safeOrganCategory} // Use safe array
        statusOptions={statusOpts}
        statusCounts={statusCounts}
        statusFilter={statusFilter}
        onStatusFilterChange={handleStatusChange}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onUndo={handleUndo}
        pagination
        itemsPerPage={itemsPerPage}
        currentPage={pagination?.page || 1}
        totalItems={pagination?.total || 0}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
        searchable
        searchTerm={searchInput}
        setSearchTerm={setSearchInput}
        onSearch={handleSearch}
        onAdd
        onAddClick={() => navigate("/organ-category-form")}
        loading={loading}
        sortKey={sortKey}
        sortOrder={sortOrder}
        onSort={handleSort}
      />
      <ViewDataPopup
        open={viewPopupOpen}
        onClose={() => setViewPopupOpen(false)}
        data={selectedRow}
      />
    </div>
  );
};

export default OrganCategory;
